import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";
import { TimesheetCode } from "@app/models/rest/timesheet-code";
import { TimesheetCodeRestService } from "@app/services/hal/timesheet-code-rest.service";

@Injectable({ providedIn: "root" })
export class TimesheetCodeStore extends RealTimeDataStore<TimesheetCode> {
  constructor() {
    const timesheetCodeRestService = inject(TimesheetCodeRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(timesheetCodeRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("TimesheetCode");
  }
}
